import { useState, ReactNode } from "react";
import { NotificationContext } from "./NotificationContext";
import { Toast, ToastToAdd, ToastToRemove } from "./types";
import uniqueId from "lodash-es/uniqueId";

const generateToastId = () => uniqueId("toast_");

type NotificationProviderProps = {
  children?: ReactNode;
  /** List of toasts to show on render. */
  initialToasts?: Toast[];
};

export const NotificationProvider = ({
  children,
  initialToasts = [],
}: NotificationProviderProps) => {
  const [activeToasts, setActiveToasts] = useState<Toast[]>(initialToasts);

  const addToasts = (toastsToAdd: ToastToAdd[]) => {
    setActiveToasts((prevToasts) => {
      const toastsWithIds = toastsToAdd.map((toast) => ({
        ...toast,
        id: generateToastId(),
      }));
      return [...prevToasts, ...toastsWithIds];
    });
  };

  const removeToasts = (toastsToRemove: ToastToRemove[]) => {
    setActiveToasts((prevToasts) => {
      const toastsToRemoveIds = toastsToRemove.map((toast) => toast.id);
      const remainingToasts = prevToasts.filter((toast) => {
        return !toastsToRemoveIds.includes(toast.id);
      });
      return remainingToasts;
    });
  };
  return (
    <NotificationContext.Provider
      value={{ activeToasts, addToasts, removeToasts }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
